export default {
  authSuccess: (state, auth_greennCourse) => {
    state.auth_greennCourse = auth_greennCourse;
  },
  authLogout: (state) => {
    state.auth_greennCourse = null;
  },
  userCustomFields: (state, resp) => {
    state.userCustomFields = resp;
  },
  setEmail: (state, value) => {
    state.email = value
  },
  setDocument: (state, value) => {
    state.document = value
  },
  setPassword: (state, value) => {
    state.password = value
  },
  setConfirmPassword(state, value) {
    state.confirmPassword = value;
  },
  setButtonIsDisabled(state, value) {
    state.buttonIsDisabled = value;
  },
  setFreeCourses(state, value) {
    state.freeCourses = value;
  },
  setLogo(state, value) {
    state.logo = value;
  },
  setColor(state, value) {
    state.color = value;
  },
  setBackgroundImage(state, value) {
    state.backgroundImage = value;
  },
  setUrlBackground(state, value) {
    state.urlBackground = value;
  },
  setThemeFixedPanel(state, value) {
    state.themeFixedPanel = value;
  },
}